/* tslint:disable */
/* eslint-disable */
/**
 * BlackFriday API
 * The API Documentation for BlackFriday
 *
 * The version of the OpenAPI document: 0.1
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from "../runtime";
/**
 *
 * @export
 * @interface PlatformSyncStatusDTOLastRun
 */
export interface PlatformSyncStatusDTOLastRun {
  /**
   *
   * @type {number}
   * @memberof PlatformSyncStatusDTOLastRun
   */
  runId: number;
  /**
   *
   * @type {string}
   * @memberof PlatformSyncStatusDTOLastRun
   */
  status: PlatformSyncStatusDTOLastRunStatusEnum;
  /**
   *
   * @type {Date}
   * @memberof PlatformSyncStatusDTOLastRun
   */
  finishedAt?: Date | null;
}

/**
 * @export
 */
export const PlatformSyncStatusDTOLastRunStatusEnum = {
  RUNNING: "RUNNING",
  SUCCESS: "SUCCESS",
  FAILED: "FAILED"
} as const;
export type PlatformSyncStatusDTOLastRunStatusEnum =
  typeof PlatformSyncStatusDTOLastRunStatusEnum[keyof typeof PlatformSyncStatusDTOLastRunStatusEnum];

/**
 * Check if a given object implements the PlatformSyncStatusDTOLastRun interface.
 */
export function instanceOfPlatformSyncStatusDTOLastRun(value: object): boolean {
  let isInstance = true;
  isInstance = isInstance && "runId" in value;
  isInstance = isInstance && "status" in value;

  return isInstance;
}

export function PlatformSyncStatusDTOLastRunFromJSON(json: any): PlatformSyncStatusDTOLastRun {
  return PlatformSyncStatusDTOLastRunFromJSONTyped(json, false);
}

export function PlatformSyncStatusDTOLastRunFromJSONTyped(
  json: any,
  ignoreDiscriminator: boolean
): PlatformSyncStatusDTOLastRun {
  if (json === undefined || json === null) {
    return json;
  }
  return {
    runId: json["runId"],
    status: json["status"],
    finishedAt: !exists(json, "finishedAt")
      ? undefined
      : json["finishedAt"] === null
      ? null
      : new Date(json["finishedAt"])
  };
}

export function PlatformSyncStatusDTOLastRunToJSON(value?: PlatformSyncStatusDTOLastRun | null): any {
  if (value === undefined) {
    return undefined;
  }
  if (value === null) {
    return null;
  }
  return {
    runId: value.runId,
    status: value.status,
    finishedAt:
      value.finishedAt === undefined ? undefined : value.finishedAt === null ? null : value.finishedAt.toISOString()
  };
}
